import api from './axios';
import { Product } from '../types/product';

export interface SearchParams {
  q: string;
  page: number;
  sortBy?: 'relevance' | 'new' | 'popular' | 'price_low' | 'price_high';
  limit?: number;
}

export interface SearchResponse {
  success: boolean;
  products: Product[];
  pagination: {
    page: number;
    limit: number;
    totalCount: number;
    totalPages: number;
    hasNext: boolean;
    hasPrev: boolean;
  };
  query: {
    searchTerm: string;
    sortBy: string;
    filters: Record<string, any>;
  };
}

export interface SearchSuggestion {
  type: 'brand' | 'category' | 'product';
  text: string;
  textZh: string;
  textCn: string;
  id?: number;
}

export interface SearchSuggestionsResponse {
  success: boolean;
  suggestions: SearchSuggestion[];
  query: string;
}

export const searchApi = {
  searchProducts: async (params: SearchParams): Promise<SearchResponse> => {
    try {
      const queryParams = new URLSearchParams({
        q: params.q,
        page: params.page.toString(),
        sortBy: params.sortBy || 'relevance',
        ...(params.limit && { limit: params.limit.toString() }),
      });

      const response = await api.get(`/api/shop/search/products?${queryParams}`);
      return response.data;
    } catch (error) {
      console.error('Error searching products:', error);
      throw error;
    }
  },

  getSearchSuggestions: async (query: string, limit: number = 8): Promise<SearchSuggestionsResponse> => {
    try {
      const response = await api.get(`/api/shop/search/suggestions?q=${encodeURIComponent(query)}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching search suggestions:', error);
      throw error;
    }
  },
};
